<template>
  <div class="checkoutProduct">
    <!-- Alternative product card section -->
    <v-product-card
      id="altertnateProduct"
      v-if="showRelationalProduct && relationalProduct"
      :product="relationalProduct"
      :atpDetails="relationshipATPDetails"
      relational-product
      @add-relational-product="addRelationalProduct"
    ></v-product-card>
    <!-- Actual product card section -->
    <v-product-card
      id="availableProduct"
      :product="product"
      :available="!showRelationalProduct"
      :atpDetails="ATPDetails"
      @update="handleShoppingCartItemUpdate"
      @remove="handleShoppingCartItemRemove"
      @atp="getATPCheck"
    ></v-product-card>
  </div>
</template>

<script>
import VProductCard from './ProductCard';
import { ref, watch, onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'CheckoutProduct',
  components: {
    VProductCard
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  emits: ['update', 'remove', 'add'],
  setup(props, { emit }) {
    const store = useStore();
    const showRelationalProduct = ref(false);
    const ATPDetails = ref({});
    const relationshipATPDetails = ref(null);
    const relationalProduct = ref(null);

    const getATPCheck = (product) => {
      showRelationalProduct.value = false;
      relationalProduct.value = null;

      // Skip ATP check for products with MaterialStatusCode = 30
      if (String(product.MaterialStatusCode) === '30') {
        ATPDetails.value = {};
        return;
      }

      store
        .dispatch('cart/fetchATPDetail', { productId: product.productId, quantity: product.quantity })
        .then((response) => {
          if (response && response.data && response.data.ATPResponse) {
            showRelationalProduct.value = response.data.ATPResponse.ATPCheckColorCode === '7';
            ATPDetails.value = response.data.ATPResponse;
          }
        });
    };

    const handleShoppingCartItemUpdate = (item) => {
      emit('update', item);
    };

    const handleShoppingCartItemRemove = (item) => {
      emit('remove', item);
    };

    const addRelationalProduct = () => {
      emit('add', { productId: relationalProduct.value.productId, count: props.product.quantity });
      handleShoppingCartItemRemove(props.product);
    };

    const findAvailableRelationalProduct = async () => {
      if (!props.product.relationalProducts) {
        return;
      }
      let productQuantity = props.product.quantity;
      let availableRelationalProduct = null;
      for (let relation of props.product.relationalProducts) {
        // Skip ATP check for relational products with MaterialStatusCode = 30
        if (String(relation.MaterialStatusCode) === '30') {
          continue;
        }

        let atpCheck = await store.dispatch('cart/fetchATPDetail', {
          productId: relation.productId,
          quantity: productQuantity
        });
        if (!atpCheck || !atpCheck.data || !atpCheck.data.Success) {
          continue;
        }

        // not showing products with unknown delivery time as alternatives
        let result = atpCheck.data.ATPResponse.ATPCheckColorCode;
        if (result === '7') {
          continue;
        }

        // found first available alternative, no need to continue
        if (result === '1' || result === '2') {
          relationshipATPDetails.value = atpCheck.data.ATPResponse;
          availableRelationalProduct = relation;
          break;
        }

        if (
          !relationshipATPDetails.value ||
          (relationshipATPDetails.value && result < relationshipATPDetails.value.ATPCheckColorCode)
        ) {
          relationshipATPDetails.value = atpCheck.data.ATPResponse;
          availableRelationalProduct = relation;
        }
      }
      relationalProduct.value = availableRelationalProduct;
    };

    watch(
      () => showRelationalProduct,
      (newVal) => {
        if (newVal) {
          findAvailableRelationalProduct();
        }
      },
      { immediate: true }
    );

    onMounted(() => {
      getATPCheck(props.product);
    });

    return {
      showRelationalProduct,
      ATPDetails,
      relationshipATPDetails,
      relationalProduct,
      getATPCheck,
      handleShoppingCartItemUpdate,
      handleShoppingCartItemRemove,
      addRelationalProduct,
      findAvailableRelationalProduct
    };
  }
};
</script>
